import "./index.css";

import { Auth0Provider } from "@auth0/auth0-react";
import mixpanel from "mixpanel-browser";
import { createRoot } from "react-dom/client";

import App from "./App.tsx";
import config from "./config.ts";
import { initSentry } from "./lib/sentry.ts";

initSentry();

mixpanel.init("d3c0d14ba5a4863c1608ac7bbff08617", {
  debug: config.env === "development",
  track_pageview: true,
  autocapture: true,
  ignore_dnt: true,
  persistence: "localStorage",
});
mixpanel.register({ environment: config.env });

createRoot(document.getElementById("root")!).render(
  <Auth0Provider
    cacheLocation="localstorage" // keep RT after full page reloads
    useRefreshTokens={true} // prefer refresh-token rotation
    useRefreshTokensFallback={true} // fall back to iframe if RT missing
    domain={config.auth0Domain}
    clientId={config.auth0ClientId}
    authorizationParams={{
      redirect_uri: window.location.origin,
      audience: config.auth0Audience,
      scope: "openid profile email offline_access",
    }}
  >
    <App />
  </Auth0Provider>
);
